import React, { Component } from 'react';

import './Lightbox.css';

class Lightbox extends Component {
	constructor(props) {
		super();
		this.state= {
			images: props.images,
			currentId: props.currentId,
			maxHeight: window.innerHeight
		}
		document.body.onresize= () => this.setState({
			maxHeight: window.innerHeight
		});
	}

	previous() {
		console.log('Lightbox previous');
		const currentId= this.state.currentId;
		const length= this.state.images.length;
		this.setState({
			currentId: (currentId-1+length)%length
		})
	}

	next() {
		console.log('Lightbox next');
		this.setState({
			currentId: (this.state.currentId+1)%this.state.images.length
		})
	}

	render() {
		return (
			<div className="cbp-popup-wrap cbp-popup-lightbox cbp-popup-ready" data-action="close" style={{display: 'block'}}>
        		<div className="cbp-popup-content">
        			<div className="cbp-popup-lightbox-figure" onClick={this.next.bind(this)}>
        				<img src={ this.state.images[this.state.currentId] } className="cbp-popup-lightbox-img" data-action="next" style={{maxHeight: this.state.maxHeight-80}} />
        				<div className="cbp-popup-lightbox-bottom">
        					<div className="cbp-popup-lightbox-title">Title</div>
        					<div className="cbp-popup-lightbox-counter">
        						{this.state.currentId+1} de {this.state.images.length}
        					</div>
        				</div>
        			</div>
        		</div>
        		<div className="cbp-popup-loadingBox"></div>
        		<div className="cbp-popup-navigation-wrap">
        			<div className="cbp-popup-navigation">
        				<div onClick={this.props.onClose} className="cbp-popup-close" title="Close (Esc arrow key)" data-action="close"></div>
        				<div onClick={this.next.bind(this)} className="cbp-popup-next" title="Next (Right arrow key)" data-action="next" style={{display: 'block'}}></div>
        				<div onClick={this.previous.bind(this)} className="cbp-popup-prev" title="Previous (Left arrow key)" data-action="prev" style={{display: 'block'}}></div>
        			</div>
        		</div>
        	</div>
		)
	}
}

export default Lightbox;